"use client"

import React from 'react';

export default function EnvelopeCTA({
  title = "How To Apply",
  description = "If all of this excites you, email your detailed resume with the subject line indicating the relevant opening.",
  email = "hr@maxiomwealth.com",
  buttonText = "Apply Now",
  onButtonClick = () => window.open(`https://mail.google.com/mail/?view=cm&to=hr@maxiomwealth.com`, '_blank'),
}) {
  return (
    <div className="mx-auto my-8 max-w-full px-2 sm:my-12 sm:max-w-2xl md:max-w-3xl lg:max-w-4xl">
      <div
        className="relative overflow-hidden rounded-lg shadow-lg transition-all duration-300 bg-white"
      >
        {/* Envelope flap */}
        <div
          className="absolute left-0 right-0 top-0 z-10 h-16 w-full origin-top bg-[#113262] shadow-md transition-all duration-500 translate-y-0 rotate-0 sm:h-20 md:h-24"
          style={{
            clipPath: "polygon(0 0, 50% 100%, 100% 0)",
          }}
        />

        {/* Envelope body */}
        <div className="relative z-0 bg-white">
          {/* Envelope content */}
          <div className="flex flex-col items-center justify-center space-y-4 bg-[#E8EEF6] px-3 py-8 text-center sm:space-y-6 sm:px-6 sm:py-12 pt-24 sm:pt-32">
            <h3 className="text-xl font-bold text-[#113262] sm:text-2xl md:text-3xl">{title}</h3>
            <p className="max-w-xs text-[#333333] text-base sm:max-w-xl sm:text-lg">{description}</p>
            <p className="text-lg font-bold text-[#F49611] sm:text-xl">{email}</p>
            <button
              onClick={onButtonClick}
              className="rounded-md bg-[#F49611] px-6 py-2 text-base font-medium text-white transition-transform duration-200 hover:bg-[#F6A839] hover:scale-105 shadow-md sm:px-8 sm:py-3 sm:text-lg"
            >
              {buttonText}
            </button>
          </div>

        </div>
      </div>
    </div>
  );
}